module.exports = __webpack_public_path__ + "static/media/mob1.ec381055.png";